<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="型号名称">
                <a-input @keyup.enter="handleQuery" v-model="queryParam.modelName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="产品规格名称">
                <a-input @keyup.enter="handleQuery" v-model="queryParam.modelCaliberName" placeholder="请输入"
                  allow-clear />
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="24">
              <a-form-item label="设备编号">
                <a-input v-model="queryParam.devCode" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col> -->
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户编码">
                  <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户编码">
                  <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="信用代码">
                  <a-input v-model="queryParam.socialCreditCode" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="联系人">
                  <a-input v-model="queryParam.contacts" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="电话">
                  <a-input v-model="queryParam.mobile" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 正常 </a-select-option>
                    <a-select-option :value="1"> 异常关闭 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户类型">
                  <a-select placeholder="请选择" v-model="queryParam.type" style="width: 100%" allow-clear>
                    <a-select-option :value="1"> 厂商 </a-select-option>
                    <a-select-option :value="2"> 经销商 </a-select-option>
                    <a-select-option :value="3"> 分经销商 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="营业状态">
                  <a-select placeholder="请选择" v-model="queryParam.tradeStatus" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 营业中 </a-select-option>
                    <a-select-option :value="10"> 维修升级中 </a-select-option>
                    <a-select-option :value="60"> 暂停营业 </a-select-option>
                    <a-select-option :value="70"> 隐藏 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="省">
                  <a-input v-model="queryParam.province" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="市">
                  <a-input v-model="queryParam.city" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="区">
                  <a-input v-model="queryParam.area" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
<template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="时间范围">
                  <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onChange" />
                </a-form-item>
              </a-col>
            </template> -->
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(options)" v-hasPermi="['abm-fix:integral:add']"
          v-if="userType !== 0">
          设置单独积分
        </a-button>
        <a-button type="primary" @click="handleDeletes(true)" v-hasPermi="['abm-fix:integral:unify']">
          积分赋能开
        </a-button>
        <a-button type="primary" @click="handleDeletes(false)" v-hasPermi="['abm-fix:integral:unify']">
          积分赋能关
        </a-button>
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['abm-fix:model:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['abm-fix:dev:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['abm-fix:model:remove']">
          <a-icon type="delete" />删除
        </a-button> -->
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['abm-fix:dev:export']">
          <a-icon type="download" />导出
        </a-button> -->
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" />
      </div>
      <attributeForm ref="attributeForm" @ok="getList" />
      <!-- 增加修改 -->
      <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" />
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        :bordered="tableBordered">
        <!-- <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span> -->
        <span slot="openEnablingIntegral" slot-scope="text, record">
          <a-tag color="green" v-if="record.openEnablingIntegral"> 开 </a-tag>
          <a-tag color="red" v-else> 关 </a-tag>
        </span>
        <span slot="name" slot-scope="text, record"> {{ record.name }}-{{ record.code }} </span>
        <span slot="productName" slot-scope="text, record"> {{ record.productName }}-{{ record.name }}-{{
          record.optionalUnit
          }} </span>

        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['abm-fix:integral:one']"> 赋能 </a>
          <a @click="$refs.attributeForm.init(record.modelCaliberId, record.modelCaliberId)" v-hasPermi="['abm:181b77bf19539e06:list']"> 属性 </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, statusObj, addOne, addTy } from '@/api/pressure/specifications'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import attributeForm from '../model/modules/attributeForm.vue'
export default {
  name: 'Post',
  components: {
    CreateForm,
    attributeForm
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      options: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '型号名称',
          dataIndex: 'productName',
          scopedSlots: { customRender: 'productName' },
          align: 'center',
        },
        // {
        //   title: '型号编号',
        //   dataIndex: 'productCode',
        //   align: 'center',
        // },
        // {
        //   title: '型号单位',
        //   dataIndex: 'optionalUnit',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '产品规格名称',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '规格口径序列号',
        //   dataIndex: 'modelSort',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '规格口径编号',
        //   dataIndex: 'code',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '所属单位名称',
          dataIndex: 'tenantFirmName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '经销商金豆',
          dataIndex: 'agentIntegral',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '验收员积分',
          dataIndex: 'testIntegral',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '水工积分',
          dataIndex: 'waterIntegral',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '设备编号',
        //   dataIndex: 'devCode',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '租户简称',
        //   dataIndex: 'referredName',
        //   align: 'center',
        // },
        {
          title: '赋能',
          dataIndex: 'openEnablingIntegral',
          scopedSlots: { customRender: 'openEnablingIntegral' },
          align: 'center',
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'createTime' },
        //   align: 'center',
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '80px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      //       agentIntegral
      // : 
      // "1"
      // modelCaliberId
      // : 
      // "544575401914224641"
      // modelId
      // : 
      // "544575400995672064"
      // tenantFirmId
      // : 
      // "476015120804347905"
      // testIntegral
      // : 
      // "1"
      // waterIntegral
      // : 
      // "1"
      const arr = []
      selectedRows.forEach(v => {
        arr.push(v.modelCaliberId)
      })
      this.options = arr
      console.log(arr, 'arrarrarrarr');

      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDeletes(e) {
      const that = this
      // this.ids
      const text = e ? '是否统一积分赋能全开' : '是否统一积分赋能全关'
      this.$confirm({
        title: text,
        onOk() {
          return addTy({ openEnablingIntegral: e }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() { },
      })
    },
    // 禁用启用
    handleDelete(row) {
      var that = this
      // let ids = []
      // if (row.id) {
      //   ids = [row.id]
      // } else {
      //   ids = this.ids
      // }
      const text = row.openEnablingIntegral ? '是否积分赋能关?' : '是否积分赋能开?'
      this.$confirm({
        title: text,
        onOk() {
          return addOne({ id: row.id, openEnablingIntegral: row.openEnablingIntegral ? false : true }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
  },
}
</script>
